<h4 class="modal-header">
</h4>
<div class="modal-body line">
    <p>{{message}}</p>
</div>
<div class="modal-footer">
    <button class="btn text-dark d-inline-block mx-3" (click)="onCancel()">{{cancelBtn}}</button>
    <button class="btn btn-primary" (click)="onConfirm()">{{okBtn}}</button>
</div>